import * as yup from "yup";

const GuestData = {
  packageInitValues: {
    name: "",
    email: "",
    price: 0,
    discountedPrice: 0,
    adults: 0,
    kids: 0,
    desc: "",
    seatCustomized: false,
    status: false,
  },
  initialValues: {
    experienceId: "",
    requestId: "",
    userDetails: {
      mobileNumber: "",
      countryCode: "+91",
      name: "",
      fcmToken: "",
      email: "",
    },
    adultCount: 0,
    adultPrice: 0,
    adultPriceChanged: false,
    occasion: "",
    kidsCount: 0,
    kidsPrice: 0,
    kidPriceChanged: false,
    package: {
      name: "",
      count: 0,
      price: 0,
      adults: 0,
      kids: 0,
      addMore: false,
    },
    userId: "",
    highchairAccess: false,
    highchairCount: 0,
    handicapCount: 0,
    reservationTime: "",
    reservationDate: "",
    tableNo: "",
    paymentData: {
      paymentMethod: 0,
      totalAmount: 0,
      amount: 0,
      donationAmount: 0,
    },
    donation: 0,
    restaurantId: "",
    vendorId: "",
    seatingPreference: "",
    taxes:{},
    taxesTotal:0,
    surCharges:{},
    surChargesTotal:0
  },
  validation: yup.object({
    userDetails: yup.object({
      name: yup
        .string()
        .required("Name is required")
        .max(64, "Maximum 64 Characters"),
      mobileNumber: yup.number().required("phone number is required"),
      // .max(11,"max 10 digits"),
    }),
    reservationDate: yup.string().required("reservation Date is required"),
    reservationTime: yup.string().required("Reservation Time Slot is required"),
    adultCount: yup
      .number()
      .when("package", {
        is: (val) => val.adults <= 0,
        then: yup.number()
          .min(1, "Min 1 Adult")
          .required("Adult count is required")
          .positive(),
      }),
  }),
};

export default GuestData;
